import { render, staticRenderFns } from "./PublishingContractsCostsReadOnlyPanel.vue?vue&type=template&id=5d7d09a2"
import script from "./PublishingContractsCostsReadOnlyPanel.vue?vue&type=script&lang=js"
export * from "./PublishingContractsCostsReadOnlyPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports